import 'prosemirror-view/style/prosemirror.css';
import './style/prosemirror.css';
import React, { useCallback, useEffect } from 'react';
import { useEditorView } from './EditorProvider';
export var Editor = React.memo(function (_a) {
    var _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b;
    var view = useEditorView();
    var editorRef = useCallback(function (element) {
        if (element) {
            element.appendChild(view.dom);
        }
    }, [view]);
    useEffect(function () {
        if (autoFocus) {
            view.focus();
        }
    }, [autoFocus, view]);
    return React.createElement("div", { ref: editorRef, className: "prosemirror-editor" });
});
Editor.displayName = 'Editor';
